import React, { useState } from 'react'

import CustomCheckOrRadio from './../../../widgets/custom_check'

const initialStates = {
  is_custom_cheked: true
}

const ProductIsCustomCheckbox = ({ onStateChange }) => {

  const [state, setState] = useState(initialStates)

  const onValueChange = () => {
    setState((prevState) => ({
      ...prevState,
      is_custom_cheked: !prevState.is_custom_cheked
    }))

    onStateChange('is_custom', !state.is_custom_cheked)
  }

  return (
    <div className="product-is-custom-check">
      <CustomCheckOrRadio
        type="checkbox"
        checked={state.is_custom_cheked}
        onValueChange={onValueChange}
      />
      <span>Custom</span>
    </div>
  )
}

export default ProductIsCustomCheckbox